import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const CourseTabs = ({ activeTab, onTabChange, lessonCount, activityCount }) => {
  const tabs = [
    {
      id: 'lessons',
      label: 'Lições Completas',
      icon: 'PlayCircle',
      count: lessonCount
    },
    {
      id: 'highlights',
      label: 'Melhores Momentos',
      icon: 'Star',
      count: null
    },
    {
      id: 'activities',
      label: 'Atividades',
      icon: 'CheckSquare',
      count: null
    },
    {
      id: 'overview',
      label: 'Visão Geral',
      icon: 'Info',
      count: null
    }
  ];

  return (
    <div className="border-b border-border mb-8">
      <div className="flex overflow-x-auto scrollbar-hide">
        {tabs?.map((tab) => (
          <button
            key={tab?.id}
            onClick={() => onTabChange(tab?.id)}
            className={`flex items-center space-x-2 px-6 py-4 border-b-2 transition-micro whitespace-nowrap ${
              activeTab === tab?.id
                ? 'border-primary text-primary' :'border-transparent text-muted-foreground hover:text-foreground hover:border-muted'
            }`}
          >
            <Icon name={tab?.icon} size={18} />
            <span className="font-medium">{tab?.label}</span>
            {tab?.count && (
              <span className={`px-2 py-1 rounded-full text-xs font-medium ${
                activeTab === tab?.id
                  ? 'bg-primary text-primary-foreground'
                  : 'bg-muted text-muted-foreground'
              }`}>
                {tab?.count}
              </span>
            )}
          </button>
        ))}
      </div>
    </div>
  );
};

export default CourseTabs;